import { mapActions, mapMutations } from 'vuex'

export default {
  ...mapActions('app/patient/agendas', [
    'loadAgendas'
  ]),
  ...mapMutations('app/patient/agendas', [
    'setLoading',
    'setFilterPage'
  ]),
  setPage (page) {
    this.setFilterPage(page)
    this.loadAgendas()
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/resources/methods.js